import { Component, inject, OnInit } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { LockerSpirit } from '../../../../../core/models/lockerSpirit.model';
import { ApiService } from '../../../../../core/services/api.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

const materialModules = [
  MatIconModule,
  MatDialogModule,
  MatButtonModule
]

@Component({
  selector: 'app-spirit-detail-locker-delete',
  standalone: true,
  imports: [TranslateModule, ...materialModules],
  templateUrl: './spirit-detail-locker-delete.component.html',
  styleUrls: ['./spirit-detail-locker-delete.component.scss']
})
export class SpiritDetailLockerDeleteComponent implements OnInit {

  api = inject(ApiService);

  lockerSpirit: LockerSpirit | null = null;
  lockerUser: any = null;

  constructor(
    private dialogRef: MatDialogRef<SpiritDetailLockerDeleteComponent>
  ) { }

  ngOnInit(): void {
  }

  delete() {
    this.api.deleteLockerSpirit(this.lockerUser.code, this.lockerSpirit!.uuid).subscribe(
      data => {
        if (data.success) {
          this.dialogRef.close('deleted');
        }
      }
    );
  }

  close() {
    this.dialogRef.close();
  }

}
